module.exports = __webpack_public_path__ + "static/media/capsule_machine_hk_ori.5c98928f.png";